import React, { useEffect, useState } from 'react';
import { TextField } from '@mui/material';

function toInitialNumber(value) {
    if (value === null || value === '') {
        return '';
    }
    if (typeof value === 'number' && !isNaN(value)) {
        return (value / 100).toFixed(2);
    }
    if (typeof value === 'string') {
        const parsed = parseFloat(value);
        if (!isNaN(parsed)) {
            return (parsed / 100).toFixed(2);
        }
    }
    return '';
}

function textToNumber(value) {
    if (typeof value === 'number' && !isNaN(value)) {
        return value;
    }
    // try to handle the "us" number format 222,222.22
    value = value.replace(/,/g, '');
    if (typeof value === 'string') {
        const parsed = parseFloat(value);
        if (!isNaN(parsed)) {
            return parsed;
        }
    }
    return 0;
}
/**
 * Optimized component that only fires change on blur and formats value as dollars
 * from cents for display.
 */
function CentInput({ value, onChange, ...props }) {
    const [textValue, setTextValue] = useState(toInitialNumber(value));

    useEffect(() => {
        setTextValue(toInitialNumber(value));
    }, [value]);

    // This is a placeholder function to avoid empty file error.
    return (
        <TextField
            value={textValue}
            onBlur={() =>
                onChange({
                    target: { value: textToNumber(textValue) * 100 },
                })
            }
            onChange={(e) => setTextValue(e.target.value)}
            {...props}
        />
    );
}

export default CentInput;
